export const ValueType = {
    Numeric: "Numeric",
    String: "String",
    Boolean: "Boolean",
    Enum: "Enum",
    Array: "Array",
    Json: "Json",
    Date: "Date",
};
